module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-title/dist/template.html
 ** module id = 188
 ** module chunks = 1
 **/